import React from "react";
const TabContent = ({ role, companyName, companyWebsite, period, details }) => {
  return (
    <div>
      <h3>
        <span>{role}</span>
        <span className="company">
          &nbsp;@&nbsp;
          <a href={companyWebsite} target="_blank" title={companyName}>
            {companyName}
          </a>
        </span>
      </h3>
      <p className="range">{period}</p>
      <div className="work-detail">
        <ul></ul>
        {details.map((detail) => {
          return (
            <ul key={detail.id}>
              <li>{detail.content}</li>
            </ul>
          );
        })}
      </div>
    </div>
  );
};

export default TabContent;
